// workflow 整体状态：server 与 website 共享的纯领域逻辑。
// 零 drizzle / IO 依赖，Temporal workflow（sandbox）可安全 import。
// 与 task-status 同值集（但语义独立：此处是「整条处理流程的聚合状态」，由各 task 汇总物化）。
//   pending    - 已登记，尚未启动
//   processing - 处理中
//   retry-waiting - 至少一个 task 等待人工重试，流程仍保持打开
//   succeeded  - 终态：成功
//   failed     - 终态：失败
//   canceled   - 终态：取消

export const WORKFLOW_STATUSES = [
  'pending',
  'processing',
  'retry-waiting',
  'succeeded',
  'failed',
  'canceled',
] as const

export type WorkflowStatus = (typeof WORKFLOW_STATUSES)[number]

// 状态机：pending → processing → 终态；亦允许 pending 直达终态。
// 终态（succeeded / failed / canceled）允许集为空；自转换按非法处理。
export const WORKFLOW_STATUS_TRANSITIONS: Record<WorkflowStatus, readonly WorkflowStatus[]> = {
  pending: [
    'processing',
    'retry-waiting',
    'succeeded',
    'failed',
    'canceled',
  ],
  processing: [
    'retry-waiting',
    'succeeded',
    'failed',
    'canceled',
  ],
  'retry-waiting': [
    'processing',
    'succeeded',
    'failed',
    'canceled',
  ],
  succeeded: [],
  failed: [],
  canceled: [],
}

export const isTerminalWorkflowStatus = (status: WorkflowStatus): boolean =>
  WORKFLOW_STATUS_TRANSITIONS[status].length === 0

export const canTransitionWorkflowStatus = (from: WorkflowStatus, to: WorkflowStatus): boolean =>
  WORKFLOW_STATUS_TRANSITIONS[from].includes(to)
